import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { SelectItem } from '@valtimo/components';
import { PluginConfigurationComponent } from '@valtimo/plugin';
import { BehaviorSubject, Observable, Subscription, combineLatest, map, take } from 'rxjs';
import { TezzaConfig } from '../../models';
import { TezzaPluginService } from '../../services';

@Component({
    standalone: false,
    selector: 'valtimo-tezza-configuration',
    templateUrl: './tezza-configuration.component.html',
    styleUrls: ['./tezza-configuration.component.scss'],
})
export class TezzaConfigurationComponent
    implements PluginConfigurationComponent, OnInit, OnDestroy {
    @Input() save$: Observable<void>;
    @Input() disabled$: Observable<boolean>;
    @Input() pluginId: string;
    @Input() prefillConfiguration$: Observable<TezzaConfig>;
    @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() configuration: EventEmitter<TezzaConfig> =
        new EventEmitter<TezzaConfig>();

    readonly documentDefinitionSelectItems$!: Observable<Array<SelectItem>>;

    private saveSubscription!: Subscription;

    private readonly formValue$ = new BehaviorSubject<TezzaConfig | null>(null);
    private readonly valid$ = new BehaviorSubject<boolean>(false);

    constructor(
        private readonly tezzaPluginService: TezzaPluginService
    ) {
        this.documentDefinitionSelectItems$ = this.tezzaPluginService
            .getAllDocumentDefinitions()
            .pipe(
                map(DocumentDefinitions =>
                    DocumentDefinitions.map(DocumentDefinition => ({
                        id: DocumentDefinition.id.name,
                        text: DocumentDefinition.id.name,
                    }))
                )
            );
    }

    ngOnInit(): void {
        this.openSaveSubscription();
    }

    ngOnDestroy(): void {
        this.saveSubscription?.unsubscribe();
    }

    formValueChange(formValue: TezzaConfig): void {
        this.formValue$.next(formValue);
        this.handleValid(formValue);
    }

    private handleValid(formValue: TezzaConfig): void {
        const valid = !!(formValue.configurationTitle
            && formValue.alfrescoBaseUrl
            && formValue.username
            && formValue.password
            && formValue.tezzaAppBaseUrl
            && formValue.tezzaRmBaseUrl
            && formValue.emailFrom
            && formValue.defaultDossiers);

        this.valid$.next(valid);
        this.valid.emit(valid);
    }

    private openSaveSubscription(): void {
        this.saveSubscription = this.save$?.subscribe(save => {
            combineLatest([this.formValue$, this.valid$])
                .pipe(take(1))
                .subscribe(([formValue, valid]) => {
                    if (valid) {
                        this.configuration.emit(formValue);
                    }
                });
        });
    }
}